"use strict";

define('view/decision.header',['underscore', 'marionette', 'uikit/uikit', 'moment'], function (_, Mn, UIKit, moment) {
  var DecisionHeaderView = UIKit.Container.extend({
    options: {
      inverted: false,
      status: '',
      emptyText: '--',
      date: '',
      pending: false,
      dateFormat: 'L'
    },
    update: {
      inverted: false,
      status: false,
      date: false,
      pending: false,
      dateFormat: false
    },
    attributes: {
      style: 'word-break: normal'
    },
    initialize: function initialize() {
      UIKit.Container.prototype.initialize.apply(this, arguments);
      this.header = new UIKit.Header({
        tagName: 'strong',
        className: 'title-cell'
      });
      this.label = new UIKit.Label({
        color: 'yellow',
        text: 'Pending',
        attributes: {
          style: 'margin-top: 0.2em; margin-left: 0;'
        }
      });
      this.bindOption('inverted', 'inverted', this.header).bindOption('status', 'text', this.header);
      this.add(this.header).add(this.label);
    },
    updateAttributes: function updateAttributes() {
      var hasStatus = !!this.status;
      this.label.visible = this.pending && hasStatus;
      if (!this.pending && this.date && hasStatus) {
        this.header.subText = moment(this.date).format(this.dateFormat);
      } else if (!hasStatus) {
        this.header.subText = this.emptyText;
      } else {
        this.header.subText = '';
      }
    }
  });
  return DecisionHeaderView;
});

